import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private http: HttpClient) {}

  get(
    url: string,
    options?: { defaultFileName?: string; download?: boolean }
  ): Observable<{ data: Blob; name: string }> {
    const defaultOpts = { defaultFileName: '', download: false };
    const opts = { ...defaultOpts, ...options };
    return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
      // Extracts file name.
      map((res) => {
        // The Cors setting on api must expose this header.
        const disposition = res.headers.get('Content-Disposition') || '';
        const matches = /filename=([^;]+)/gi.exec(disposition) || [];
        const name = (matches[1] || opts.defaultFileName).trim().replace(/['"]+/g, '');
        return { res, name };
      }),
      map(({ res, name }) => ({
        data: new Blob([res.body], { type: res.headers.get('Content-Type') }),
        name
      })),
      tap((file) => opts.download && this.download(file))
    );
  }

  download(file: { data: Blob; name: string }): void {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(file.data);
    link.download = file.name;
    link.click();
  }
}
